import BaseCardBehavior from './BaseCardBehavior';
import CardStateHelper, { getCardsState, isCardTypeJoker } from '../CardStateHelper';
import { CardType } from '../../../Prototype/Level/Card/CardType';
import CardStateModifierHelper from '../CardStateModifierHelper';
import { SCORE_VALUE_CARD } from '../../../Constants/Score';
import { CardTask } from '../CardTasks';
import { getCardSuit } from '../../../Utility/CardsHelper';
import { IGameState } from '../../Game/IGameState';
import { ICardsState, ICardStateData } from '../ICardState';
import CheatsManager from 'CheatsManager';
import { CardState } from 'Prototype/Level/Card/CardState';

export default class GoldCardBehavior extends BaseCardBehavior {
    public isPlayable(state: IGameState): boolean {
        const cardState = CardStateHelper.getCardState(state, this.cardID);
        const cardsState = getCardsState(state);
        if (cardState === CardState.IN_PLAY) {
            return (
                super.isPlayable(state) &&
                this.isMatch(cardsState, CardStateHelper.getCurrentCard(cardsState)) &&
                !this.modifiersBlocking(cardsState)
            );
        }
        return super.isPlayable(state);
    }

    public isMatch(state: ICardsState, cardB: string): boolean {
        if (CheatsManager.getFirstInstance()?.shouldIgnoreCardMatchRules()) {
            return true;
        }

        const cardAData: ICardStateData = state.cards[this.cardID];
        const cardBData: ICardStateData = state.cards[cardB];
        // If nothing to match against always match.
        if (!cardBData) {
            return state.inStack.length === 0;
        }

        // If cardB is a joker always match.
        if (isCardTypeJoker(cardBData.type)) return true;

        if (cardBData.type === CardType.gold && cardAData.type === CardType.gold) {
            if (cardBData.suit === cardAData.suit) {
                return true;
            }
        }
        if (cardAData.type === CardType.gold && cardBData.type === CardType.value) {
            if (cardAData.suit === getCardSuit(cardBData.value)) {
                return true;
            }
        }

        return false;
    }

    public play(state: IGameState) {
        const cardStatus = CardStateHelper.getCardState(state, this.cardID);
        let cardsState: ICardsState = state.levelState.cardsState;
        switch (cardStatus) {
            case CardState.IN_PLAY:
                const modBehaviors = this.modifiersOverriding(state.levelState.cardsState);
                console.log(modBehaviors);
                // Modifiers can override the default 'play' method.
                if (modBehaviors.length > 0) {
                    // Modifiers are played instead.
                    for (let i = 0, n = modBehaviors.length; i < n; i++) {
                        state = CardStateModifierHelper.playModifier(
                            state,
                            modBehaviors[i].modifier,
                            modBehaviors[i].cardID
                        );
                    }
                    cardsState = getCardsState(state);
                } else {
                    cardsState = CardStateHelper.pushUndoHistory(cardsState, this.cardID, CardState.IN_PLAY);
                    cardsState = CardStateHelper.increaseStreak(cardsState, SCORE_VALUE_CARD, this.cardID);
                    const cardScore = state.levelState.cardsState.streakScore;
                    cardsState = CardStateHelper.addTurnScore(cardsState, cardScore);
                    state = CardStateHelper.updateGameState(state, cardsState);

                    cardsState = getCardsState(state);
                    cardsState = CardStateHelper.setCardFolded(cardsState, this.cardID);

                    state = CardStateHelper.updateGameState(state, cardsState);

                    // Ensure modifiers are updated after the gold card is folded. This ensures the TNT modifier is
                    // updated after and can check if the level is complete before exploding (if the timer value === 1).
                    // This is also the same order of operations as the ValueCardBehavior.
                    state = CardStateModifierHelper.updateModifiers(state, this.cardID);

                    // Get cardState again.
                    cardsState = getCardsState(state);

                    cardsState = CardStateHelper.setStateTaskData(cardsState, {
                        task: CardTask.MATCH,
                        cards: [this.cardID],
                        cardScore: cardScore,
                    });

                    // Update cards after some are discarded
                    state = CardStateHelper.updateGameState(state, cardsState);
                    state = CardStateHelper.updateCards(state);

                    state = CardStateModifierHelper.onCardPlayed(state, this.cardID);

                    cardsState = CardStateHelper.checkStreakBonus(state);

                    break;
                }

            case CardState.IN_STACK:
            case CardState.FOLDED:
            case CardState.DISCARDED:
            case CardState.UNKNOWN:
        }

        return CardStateHelper.updateGameState(state, cardsState);
    }
}
